import api from "./index";

export const getBeforeStats = async () => {
  const response = await api.get(`/beforeState.json`, { baseURL: "" });
  const data = response.data;
  const stats = data.stats.stats.statistic;

  // Z 좌표는 position 2에 있음 (X: 0, Y: 1, Z: 2)
  const zStats = stats.find((stat) => stat.name === "Z");

  return {
    count: zStats.count,
    minZ: zStats.minimum,
    maxZ: zStats.maximum,
    average: zStats.average,
    stddev: zStats.stddev,
  };
};

// export const getAfterStats = async () => {
//   const response = await api.get(`/afterState.json`, { baseURL: "" });
//   const data = response.data;
//   const stats = data.stats.stats.statistic;

//   // Z 좌표는 position 2에 있음 (X: 0, Y: 1, Z: 2)
//   const zStats = stats.find((stat) => stat.name === "Z");

//   return {
//     count: zStats.count,
//     minZ: zStats.minimum,
//     maxZ: zStats.maximum,
//     average: zStats.average,
//     stddev: zStats.stddev,
//   };
// };

export const getAfterStats = async () => {
  const response = await api.get(`/afterstats.json`, { baseURL: "" });
  const data = response.data;
  const stats = data.stages["filters.stats"][0].statistic;
  return {
    count: stats[0].count,
    minZ: stats[0].minimum,
    maxZ: stats[0].maximum,
    average: stats[0].average,
    stddev: stats[0].stddev,
  };
};
